export default class BaseCookie {
   setCookie(key, value, options = {}) {
      options = {
         path: '/',
         expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 16),
         secure: true,
         ...options,
      }
      if (options.expires instanceof Date) {
         options.expires = options.expires.toUTCString()
      }
      document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value)
      for (let optionKey in options) {
         let optionCookie = optionKey
         let optionValue = options[optionKey]
         if (optionValue !== true) {
            optionCookie += '=' + optionValue
         }
         document.cookie = optionCookie
      }
   }

   getCookie(name) {
      let matches = document.cookie.match(new RegExp(
         '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)',
      ))
      return matches ? decodeURIComponent(matches[1]) : undefined
   }

   deleteCookie(name) {
      this.setCookie(name, '', {expires: -1})
   }
}